/*  Aprire un documento preciso da un'altra schermata.

    L'ancora è già l'indirizzo di una schermata — `#commesse` apre le commesse, e si può
    incollare in una mail. Qui si aggiunge la seconda metà: `#commesse/<id>` apre quella
    commessa. Serve perché i documenti si citano a vicenda — una commessa nasce da
    un'offerta, un'offerta diventa una commessa — e un riferimento che si legge ma non si
    apre costa a chi lo legge di andare a cercarlo a mano nella griglia accanto.

    Perché l'ancora e non uno stato passato di mano in mano fra le due schermate: perché
    così il collegamento è anche un indirizzo. «Guarda la commessa 26-0001» diventa un
    link da incollare in una mail, e il tasto «indietro» del browser riporta dov'era.

    Non c'è un router, e non serve: sono due righe di stringa, e il router porterebbe con
    sé una dipendenza e un modo di pensare alle schermate che questo applicativo non ha.
*/

/// <summary>L'identificativo dentro `#vista/<id>`, o null se l'ancora non ne porta uno.</summary>
export function idDallAncora(vista: string, ancora = window.location.hash): string | null {
  const pulita = ancora.replace(/^#/, '');
  if (!pulita.startsWith(`${vista}/`)) return null;

  const id = pulita.slice(vista.length + 1).trim();

  /*  Solo quello che somiglia a un identificativo. Un'ancora scritta a mano male non deve
      far partire una chiamata al server con dentro qualunque cosa: l'errore che tornerebbe
      parlerebbe di un formato sbagliato invece che di un indirizzo sbagliato.  */
  return /^[0-9a-fA-F-]{36}$/.test(id) ? id : null;
}

/// <summary>Porta a un documento di un'altra schermata. Cambia l'indirizzo, il resto lo fa App.</summary>
export function apri(vista: string, id: string): void {
  window.location.hash = `#${vista}/${id}`;
}

/*  Torna all'elenco, lasciando l'indirizzo della sola schermata.

    Serve perché `apri` ha una metà mancante: se aprire un documento scrive l'indirizzo,
    chiuderlo deve togliercelo, altrimenti chi ricarica la pagina dopo aver chiuso si
    ritrova aperto il documento che aveva appena chiuso. Il formato dell'ancora sta scritto
    qui e in nessun altro posto, che è il motivo per cui questa è una funzione e non una
    riga scritta a mano nelle schermate.  */
export function chiudi(vista: string): void {
  window.location.hash = `#${vista}`;
}
